import axios, { AxiosResponse } from 'axios';
import { isArrayValidAndNotEmpty } from './nullChecks';
import { APPLICATION_CONFIG_URL, getJsonPath } from './constants';
import { deepMergeObjects } from './lodash';

export interface JsonFilePath {
    path: string,
    useConfigUrl?: boolean,
}

const REMOVE = 'NUACARE_REMOVE_PROPERTY';
const mergeConfigData = <T>(
    defaultConfig: T,
    extendedConfig: T,
): T => {
    const mergedObject = deepMergeObjects(defaultConfig, extendedConfig);
    return JSON.parse(JSON.stringify({ ...mergedObject }, (_key, value) => (
        value === REMOVE ? undefined : value)));
};

export const fetchAndMergeConfigJsonFiles = async <T>(
    jsonFilePath: JsonFilePath,
    appVersionNumber?: string,
): Promise<T> => {
    const errorMessage = `Failed to fetch: ${jsonFilePath.path}`;
    const defaultConfigPromise = axios.get(getJsonPath(jsonFilePath.path, { appVersionNumber }));
    if (!jsonFilePath.useConfigUrl) {
        const defaultConfig: AxiosResponse<T> = await defaultConfigPromise;
        return defaultConfig.data;
    }

    const extendedConfigPromise = axios.get(
        getJsonPath(jsonFilePath.path, { configUrl: APPLICATION_CONFIG_URL, appVersionNumber }),
    );
    const responses: Array<AxiosResponse<T>> =
        await Promise.all([defaultConfigPromise, extendedConfigPromise]);
    if (!isArrayValidAndNotEmpty(responses)) {
        throw new Error(errorMessage);
    }
    const [defaultConfig, extendedConfig] = responses;
    return mergeConfigData(defaultConfig.data, extendedConfig.data);
};
